// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"c4102cd5","453":"c3d80be0","732":"45c5e491"}[chunkId] + ".chunk.js";
};